<template>
  <div class="sp-card-content" :class="classModifiers">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { toBoolean } from "../../utils/props";
const props = defineProps({
  scrollableContent: {
    type: [Boolean, String],
    default: false,
  },
  flex: {
    type: [Boolean, String],
    default: false,
  },
  align: {
    type: String,
    default: "flex-start",
    validator: (value) => ["flex-start", "center", "flex-end"].includes(value),
  },
  justify: {
    type: String,
    default: "flex-start",
    validator: (value) => ["flex-start", "center", "flex-end"].includes(value),
  },
});

const classModifiers = computed(() => ({
  "--flex": toBoolean(props.flex),
}));
</script>

<style>
:host {
  display: block;
  height: 100%;
  box-sizing: border-box;
}
</style>

<style scoped lang="scss">
.sp-card-content {
  display: block;
  padding-inline: var(--sp-comp-card-padding-inline, 1rem);
  padding-block: var(--sp-comp-card-padding-block, 0.5rem);
  position: relative;
  height: var(--sp-comp-card-content-height, 100%);
  box-sizing: border-box;

  &.--flex {
    display: flex;
    flex-direction: column;
    align-items: v-bind(align);
    justify-content: v-bind(justify);
  }
}
</style>
